// import 'babel-polyfill';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import 'babel-polyfill';
import ReactGA from 'react-ga';
import { ToastContainer } from 'react-toastify';
import AppComponent from './AppComponent';
// import DraftModalContainer from '../modals/draftModal/DraftModalContainer';
// import ShareModalContainer from '../modals/shareModal/ShareModalContainer';
import * as appActions from './AppActions';
import * as NotFoundActions from '../notFound/NotFoundActions';
// import './Style';

class AppContainer extends Component {
  constructor() {
    super();
    this.getTour = this.getTour.bind(this);
  }

  componentWillMount() {
    try {
      window.parent.unselectTab(); /* Select "Tour Preview" tab for preview_edit. */
    } catch (parentUnselectTabError) {}
  }

  componentDidMount() {
    // ReactGA.initialize('UA-798212-2');

    window.addEventListener('message', (e) => {
      // console.log('message update', e.data);
      if (e.data.update) {
          this.props.appActions.postMessageEvent(e.data.data)
      }
  })

    const { pathname } = this.props;
    const idMatches = pathname.match(/\/([0-9]+)(\/|$)/);
    const type = pathname.match(/\/(b|u|r)(\/|$)/);
    const tourId =
      idMatches && Number.isInteger(+idMatches[1]) ? +idMatches[1] : 0;
    let tourTypeStr = type ? type[1] : '';
    let tourType = '';

    switch (tourTypeStr) {
      case 'r':
        tourType = 'restricted';
        break;
      case 'u':
        tourType = 'unbranded';
        break;
      case 'b':
        tourType = 'branded';
        break;
      default:
        tourType = 'branded';
        break;
    }

    if (tourId) {
      this.props.appActions.setUrlParams(tourId, tourType);
    } else {
      return this.props.notFoundActions.redirectToNotFound();
    }

    if (!tourTypeStr) {
      this.props.appActions.redirectToHome();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { pathname, tourId, tourType, getTourFulfilled } = this.props;
    // не зрозуміло навіщо це тут
    if (tourId !== nextProps.tourId || tourType !== nextProps.tourType) {
      this.getTour(nextProps.tourId, nextProps.tourType);
    }

    const page = pathname.match(
      /\/(gallery|floorplan|3d|walkthru|video|matterport|map|about|presented|contactagent|contactcolister)(\/|$)/
    );
    if (!page && getTourFulfilled !== nextProps.getTourFulfilled) {
      this.props.appActions.redirectToHome();
    }
  }

  getTour(tourId, tourType) {
    this.props.appActions.getTour(tourId, tourType);
  }

  render() {
    const {
      pathname,
      tourId,
      getTourFulfilled,
      contentBlur,
      menuScrollable,
      tourType
    } = this.props;
    if (
      pathname.indexOf('notFound') === -1 &&
      (tourId === 0 || !getTourFulfilled)
    ) {
      return <div className="loader" />;
    }

    const baseUrl = tourType
      ? `/${tourId}/${tourType.charAt(0)}`
      : `/${tourId}`;
    const home = baseUrl === pathname;
    const errorPage = () => {
      if (pathname === '/notProduced' || pathname === '/notFound' || pathname === '/canceled') {
        return true;
      }
      return false;
    };

    return (
      <AppComponent
        blurValue={contentBlur}
        menuScrollable={menuScrollable}
        home={home}
        errorPage={errorPage}
      >
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
        />
      </AppComponent>
    );
  }
}

AppContainer.propTypes = {
  tourId: PropTypes.number.isRequired,
  tourType: PropTypes.string,
  getTourFulfilled: PropTypes.bool.isRequired,
  isDrafted: PropTypes.bool.isRequired,
  isLogined: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
  menuScrollable: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    tourId: state.app.tourId,
    tourType: state.app.tourType,
    getTourFulfilled: state.app.getTourFulfilled,
    contentBlur: state.app.contentBlur,
    isDrafted: state.app.isDrafted,
    isLogined: state.app.isLogined,
    menuScrollable: state.menu.menuScrollable,
    pinterestImage: state.gallery.images.length
      ? state.gallery.imagesPath + state.gallery.images[0].file_name
      : '',
    pathname: state.router.location.pathname
  };
};

const mapDispatchToProps = dispatch => {
  return {
    appActions: bindActionCreators(appActions, dispatch),
    notFoundActions: bindActionCreators(NotFoundActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppContainer);
